<template>
    <div>
        <el-button type="text"  @click.stop="addGroup">添加组别</el-button>
        <div class="demo-collapse">
            <el-collapse v-model="activeGrp" @change="handleChange">
                <el-collapse-item :title="items.label" :name="index" v-for="(items,index) in queryFilter" :key="index">
                    <el-form  label-position="top">
                        <el-row  v-for="(item,code) in items.children" :key="code" style="margin-top: 5px" :gutter="20">
                            <el-col :span="2" :class="{'padd':code==0}">
                                条件{{code+1}}
                            </el-col>
                            <el-col :span="4">
                                <el-form-item label="逻辑" :class="{'itemShow':code!=0,'itemText':true}">
                                    <el-select v-model="item.logic" :disabled="code==0" placeholder="请选择">
                                        <el-option
                                                v-for="logicItem in refreshLogic"
                                                :key="logicItem.value"
                                                :label="logicItem.label"
                                                :value="logicItem.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="字段" :class="{'itemShow':code!=0,'itemText':true}">
                                    <el-select v-model="item.field" clearable placeholder="请选择">
                                        <el-option
                                                v-for="fieldItem in theHeader"
                                                :key="fieldItem.data"
                                                :label="fieldItem.label"
                                                :value="fieldItem.data"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item label="条件" :class="{'itemShow':code!=0,'itemText':true}">
                                    <el-select v-model="item.symbol" clearable placeholder="请选择">
                                        <el-option
                                                v-for="conditionItem in refreshCondition"
                                                :key="conditionItem.value"
                                                :label="conditionItem.label"
                                                :value="conditionItem.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item label="取值" :class="{'itemShow':code!=0,'itemText':true}">
                                    <el-input v-model="item.value" placeholder="请输入" clearable />
                                </el-form-item>
                            </el-col>
                            <el-col :span="3">
                               
                                <el-form-item label="操作" :class="{'itemShow':code!=0,'itemText':true}" style="text-align: center">
                                    <el-button type="text" @click.stop="removeCondition(items,index,item,code)" v-if="code!=0">删除</el-button>
                                    <el-button type="text" @click.stop="addCondition(items,index,item,code)" v-if="code==0">添加</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <template #title>
                        组别{{index+1}}
                        <div v-if="queryFilter[index].show" @click.stop>
                            <span style="margin-left: 10px">逻辑:</span>
                            <el-select style="margin-left: 10px; width: 75px" :disabled="index==0" size="mini" v-model="queryFilter[index].logic">
                                <el-option
                                        v-for="item in refreshLogic"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                >
                                </el-option>
                            </el-select>
                            <el-button style="margin-left: 10px" type="text" v-if="index!=0"  @click.stop="removeGroup(items)">删除</el-button>
                        </div>
                    </template>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
  import { ElMessageBox } from 'element-plus'
  export default {
    name: "query-config",
    props:["theHeader"],
    data(){
      return {
        activeGrp:[],//当前展开的过滤条件分组
        num1:1,//序列号
        num2:1,//序列号
        queryFilter:[{
          code:0,//组别唯一序列号
          logic:"",//与其他组别的关系
          show:false,//折叠状态
          children:[{
            logic:"",//逻辑
            field:"",//字段
            symbol:"",//条件
            value:"",//值
            code:0//条件唯一序列号
          }],
        }],//查询的条件
        refreshLogic:[{
          value: "AND",
          label: "与"
        },{
          value: "OR",
          label: "或"
        }],//查询的逻辑
        refreshCondition:[{
          value:"=",
          label:"="
        },{
          value:"!=",
          label:"!="
        },{
          value:">",
          label:">"
        },{
          value:">=",
          label:">="
        },{
          value:"<",
          label:"<"
        },{
          value:"<=",
          label:"<="
        },{
          value:"BETWEEN",
          label:"between"
        },{
          value:"IN",
          label:"in"
        },{
          value:"LIKE",
          label:"like"
        }]
      }
    },
    methods:{
      handleChange(activeNames){
        console.log(activeNames)
        console.log(this.queryFilter[0].show)
        for(var i =0;i<this.queryFilter.length;i++){
          if(activeNames.indexOf(i)!=-1){
            this.queryFilter[i].show=true;
          }else{
            this.queryFilter[i].show=false;
          }
        }
      },
      //添加条件
      addCondition(items,index,item,code){
        console.log(items,index,item,code)
        this.queryFilter[index].children.push({
          logic:"",//逻辑
          field:"",//字段
          symbol:"",//条件
          value:"",//值
          code:this.num1,
        });
        this.num1++;
      },
      //添加组别
      addGroup(){
        this.queryFilter.push({
          code:this.num2,//组别唯一序列号
          logic:"AND",//与其他组别的关系
          show:false,//折叠状态
          children:[{
            logic:"",//逻辑
            field:"",//字段
            symbol:"",//条件
            value:"",//值
            code:this.num1//条件唯一序列号
          }],
        });
        this.num2++;
        this.num1++;
        console.log(this.queryFilter)
      },
      //删除条件
      removeCondition(items,index,item,code){
        console.log(items,index,item,code)
        console.log(this.queryFilter[index].children)
        ElMessageBox.confirm(
          '你真的要删除这一条件吗',
          'warning', {
            confirmButtonText:"确认",
            cancelButtonText:"取消",
            type:"warning"
          }
        ).then(()=>{
          this.queryFilter[index].children.forEach((it,num)=>{
            if(it.code==item.code){
              this.queryFilter[index].children.splice(num,1)
            }
          })
        })


      },
      //删除组别
      removeGroup(items){
        ElMessageBox.confirm(
          '你真的要删除这一组别吗',
          'warning', {
            confirmButtonText:"确认",
            cancelButtonText:"取消",
            type:"warning"
          }
        ).then(()=>{

          this.queryFilter.forEach((item,indexs)=>{
            if(items.code==item.code){
              this.queryFilter.splice(indexs,1)
            }
          })
        })
      }
    },
    watch:{
      queryFilter:{
        handler(){
          if(this.queryFilter.length==1){
            this.queryFilter[0].show=false;
            this.queryFilter[0].logic="";
          }
          for(var i in this.queryFilter){
            this.queryFilter[i].children[0].logic="";
          }
        },
        deep:true
      },
      num1(){
        this.$emit('c', {num1:this.num1,num2:this.num2});
      },
      num2(){
        this.$emit('numChange', {num1:this.num1,num2:this.num2});
      }
    }
  }
</script>

<style>
    .itemShow .el-form-item__label{
        display:none;
    }
    .itemText .el-form-item__label{
        text-align:center
    }
</style>
<style scoped>
    .padd{
        padding-top: 55px
    }
</style>
